import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { of, Subject } from 'rxjs';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { catchError, delay, switchMap, takeUntil, tap } from 'rxjs/operators';

import { Language } from './i18n.model';
import { I18nService } from './i18n.service';

@Component({
    selector: '[cmpsI18nSwitcher]',
    template: ` <div class="corner">
        <div
            class="nav-item"
            role="none"
            ngbDropdown
            #dropdown="ngbDropdown"
        >
            <a
                class="cmps-cdk-d-block lang-select"
                href
                (click)="$event.preventDefault()"
                (keydown.arrowDown)="dropdown.open()"
                ngbDropdownToggle
            >
                <div class="d-inline-flex align-items-center">
                    <cmps-icon
                        class="cmps-cdk-fill-grey-400 cmps-cdk-mr-0dot5"
                        svgIcon="web"
                    ></cmps-icon>
                    <span>{{ currentLocale }}</span>
                    <cmps-icon
                        class="cmps-cdk-fill-grey-400"
                        [svgIcon]="
                            !dropdown.isOpen()
                                ? 'chevron-right'
                                : 'chevron-down'
                        "
                        *ngIf="!pending"
                    ></cmps-icon>
                    <cmps-icon
                        class="cmps-cdk-fill-grey-400"
                        svgIcon="progress-helper"
                        *ngIf="pending"
                    ></cmps-icon>
                </div>
            </a>
            <div
                class="lang-menu"
                role="menu"
                ngbDropdownMenu
            >
                <a
                    class="dropdown-item lang-option"
                    href
                    (click)="onLanguageSelect($event, i)"
                    (keydown.enter)="onLanguageSelect($event, i)"
                    *ngFor="let i of languageOpts"
                >
                    <cmps-icon
                        class="cmps-cdk-fill-grey-400 cmps-cdk-mr-0dot5"
                        svgIcon="web"
                    ></cmps-icon>
                    <span>{{ i.initial }}</span>
                </a>
            </div>
        </div>
    </div>`,
})
export class SwitcherI18nComponent implements OnInit, OnDestroy {
    private readonly _switchSubj: Subject<Language>;
    private readonly _doneSubj: Subject<void>;
    pending: boolean;

    get currentLocale(): string {
        return this._i18nService.currentLocale;
    }

    get languageOpts(): Language[] {
        return this._i18nService.languages;
    }

    constructor(
        private readonly _translateService: TranslateService,
        private _i18nService: I18nService,
    ) {
        this._switchSubj = new Subject();
        this._doneSubj = new Subject();
    }

    ngOnInit(): void {
        this._switchSubj
            .asObservable()
            .pipe(
                tap((language) => {
                    this._i18nService.locale = language.initial;
                }),
                // eslint-disable-next-line no-return-assign
                tap(() => (this.pending = true)),
                switchMap((language) =>
                    this._translateService
                        .use(language.id.toString())
                        .pipe(catchError(() => of(null))),
                ),
                // delay(5000),
                // eslint-disable-next-line no-return-assign
                tap(() => (this.pending = false)),
                takeUntil(this._doneSubj),
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this._doneSubj.next();
    }

    onLanguageSelect(
        $event: MouseEvent | KeyboardEvent,
        language: Language,
    ): void {
        $event.preventDefault();
        this._switchSubj.next(language);
    }
}
